export default {"src":"/_next/static/media/ic_diagonal_top_left_to_bottom_right.3a901ff9.svg","height":14,"width":31,"blurWidth":0,"blurHeight":0};